import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Modal, Image } from 'react-bootstrap';
import CloseIcon from '../../assets/images/prompt_close_icon.svg';
import PromptButton, { BUTTON_TYPES } from 'components/base/prompt/BaseButtons';
import { PermissionCodes } from 'config/PermissionCodes';
import BaseMultipleSelectorV2 from 'components/base/BaseMultipleSelectorV2';
import { createAction } from 'utils';

const mapPropsToState = (state) => ({
  customerSegments: state.customerList.customerSegments,
  customer: state.customerList.customer,
});

const EditCustomerTagModal = ({
  customerSegments,
  customer,
  show,
  setShow,
}) => {
  const dispatch = useDispatch();

  const [selectedSegments, setSelectedSegments] = useState(customer.displayInTags || []);

  const onClose = () => {
    setShow(false);
  }

  const saveAction = () => {
    const originCustomerTagPks = customer.displayInTags?.map(tag=>tag?.pk) || [];
    const selectedSegmentPks = selectedSegments?.map(tag => tag?.pk) || [];

    const addTags = selectedSegments.filter(selectSegment => !originCustomerTagPks?.includes(selectSegment?.pk))
    const removeTags = customer.displayInTags?.filter(originCustomerTag => !selectedSegmentPks?.includes(originCustomerTag?.pk))
    dispatch(createAction("customerList/updateCustomer")({
      data: {
        ...customer,
        addTags,
        removeTags,
      },
      customer: customer,
      refreshCustomer: true,
    }))
  };


  useEffect(() => {
    if (show) {
      setSelectedSegments(customer.displayInTags || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show])

  return (
    <Modal
      show={show}
      onHide={onClose}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop='static'
    >
      <Modal.Body className={`base-prompt-container customer-detail-prompt-customer-group`}>
        <Image
          src={CloseIcon}
          className="base-prompt-close-button customer-detail-prompt-close-button"
          onClick={onClose}
        />

        <label className='customer-detail-modal-title'>
          {"Edit customer tag (Static segment)"}
        </label>

        <BaseMultipleSelectorV2
          title={'Static segment'}
          data={{
            sourceData: customerSegments,
            targetData: selectedSegments,
            targetChange: (value) => {
              setSelectedSegments(value);
            },
          }}
        />
        <div className="base-prompt-buttons customer-detail-prompt-buttons">
          <PromptButton
            title='Cancel'
            action={onClose}
            type={BUTTON_TYPES.secondary}
          />
          <PromptButton
            title='Confirm'
            action={saveAction}
            requires={PermissionCodes.changeCustomer}
            type={BUTTON_TYPES.main}
          />
        </div>

      </Modal.Body>
    </Modal>
  );
}

export default connect(mapPropsToState)(EditCustomerTagModal);
